module.exports = __webpack_public_path__ + "img/441.9fc814ab.jpg";